module.exports = __webpack_public_path__ + "static/media/iphone_14_blue.9d24a6ed.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_blue.jpeg
// module id = 2121
// module chunks = 0